export default __webpack_public_path__ + "static/media/icon-hide.0998abd6.svg";